/**
 * Animations have been removed entirely for performance reasons —
 * page-reveal fade and scroll-triggered fade-ins both nuked. The file
 * survives only as a no-op shim so any consumer that still does
 * `import { Animations } from "animations"` (e.g. tabbed-content.js)
 * continues to load without errors. Nothing here runs work, schedules
 * timers, or touches the DOM.
 */

class Animations {
  static resetAnimations() {}
  static setRevealedState() {}
}

const PageAnimations = {
  setup: () => {},
  setupSingle: () => {},
  setupSequence: () => {},
};

export default PageAnimations;
export { Animations };
